import Cookies from 'js-cookie';
import getConfig from '../config';
import { getFeatureFlagValue } from './featureFlags';

/**
 * Checks if the user is authenticated by checking for either the hint cookie or the isAuth cookie,
 * depending on the showUserAccountContextUsingAPTCookie feature flag.
 *
 * @returns {boolean} true if an authentication cookie exists, false if not set or in SSR environment
 */
export const isUserAuthenticated = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const { constants = {} } = getConfig();
  const { hintCookieKey, isAuthCookieKey } = constants;

  const useHintCookie =
    getFeatureFlagValue('showUserAccountContextUsingAPTCookie', false) ===
      true && getFeatureFlagValue('useHintCookie', false) === true;

  if (useHintCookie) {
    // If the flags are on, we must also have the hintCookieKey (target auth implementation)
    if (!hintCookieKey) {
      return false;
    }
    return !!Cookies.get(hintCookieKey);
  }

  // Otherwise, we must have the isAuthCookieKey (legacy implementation)
  if (!isAuthCookieKey) {
    return false;
  }
  return Cookies.get(isAuthCookieKey)?.trim() === '1';
};

export const getAuthGuidFromAccountContextCookie = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const accountContextCookieKey = getConfig().constants
    ?.accountContextCookieKey;
  if (!accountContextCookieKey) {
    return undefined;
  }
  const accountContextCookieValue = Cookies.get(accountContextCookieKey);
  if (typeof accountContextCookieValue === 'string') {
    const trimmedValue = accountContextCookieValue.trim();
    return trimmedValue || undefined;
  }
  return undefined;
};
